import config from './config';

export default {
  defaultTitle: 'VuSocial — Daily Branded AI Videos for Insurance & Financial Advisors',
  description: 'Daily AI videos with your voice & brand, auto-posted to all your socials. Built for insurance agents & financial advisors.',
  canonical: 'https://www.vusocial.com/',
  additionalLinkTags: [
    {
      rel: 'icon',
      href: `${config.imgBaseUrl}/favicon.ico`,
    },
  ],
  openGraph: {
    type: 'website',
    site_name: 'Vusocial',
    url: 'https://www.vusocial.com',
    title: 'VuSocial — Daily Branded AI Videos for Insurance & Financial Advisors',
    description: 'Daily AI videos with your voice & brand, auto-posted to all your socials. Built for insurance agents & financial advisors.',
    images: [
      {
        url: 'https://dofimomuk6s4.cloudfront.net/files/th-home-page.jpg',
        width: 1200,
        height: 670,
        alt: 'vusocial',
      },
    ],
  },
  additionalMetaTags: [
    // Twitter Card
    { property: 'twitter:title', content: "Hyper-Local Real Estate Ready-Made Videos | Convert Leads | vusocial" },
    {
      property: 'twitter:description',
      content: "Helping Real Estate Agents, Loan Officers, Realtors, and Mortgage Brokerages to establish trust through tailored real estate websites, personalized videos, and advanced lead capturing tools. Convert real estate audience to leads with vusocial profile."
    },
    { property: 'twitter:image', content: 'https://dofimomuk6s4.cloudfront.net/files/th-home-page.jpg' },
  ],
  twitter: {
    cardType: 'summary_large_image',
  }
}
